export const EXCMCUSTOMFIELD_SHOW_RESET = 'EXCMCUSTOMFIELD_SHOW_RESET'
export const EXCMCUSTOMFIELD_SHOW_SET_ERROR = 'EXCMCUSTOMFIELD_SHOW_SET_ERROR'
export const EXCMCUSTOMFIELD_SHOW_SET_RETRIEVED = 'EXCMCUSTOMFIELD_SHOW_SET_RETRIEVED'
export const EXCMCUSTOMFIELD_SHOW_TOGGLE_LOADING = 'EXCMCUSTOMFIELD_SHOW_TOGGLE_LOADING'
